import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Button';
import useAuthentication from '../../../hooks/useAuthentication';
import { useTranslation } from 'react-i18next';

function AsLinkLoginButton({ children }) {
  const { login } = useAuthentication();
  const { t } = useTranslation();
  return (
    <Button asLink={true} onPress={login} ariaLabel={t('styleguide:link_to') + ' ' + t('styleguide:sign_in_soft')}>
      {children}
    </Button>
  );
}

AsLinkLoginButton.propTypes = {};

export default AsLinkLoginButton;
